import api from "./api";

const companySmtpService = {
  getConfig: async (token) => {
    const res = await api.get("/company-smtp", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  saveConfig: async (payload, token) => {
    const res = await api.put("/company-smtp", payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },

  testConfig: async (to, token) => {
    const res = await api.post(
      "/company-smtp/test",
      { to },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return res.data;
  },
};

export default companySmtpService;
